@if (!embedded) {
<h2 mat-dialog-title class="schema-dialog-title">
  <span>{{'contentTypes.schema' | translate}}</span>
  @if (totalFieldCount) {
    <span class="field-count">{{totalFieldCount}} {{'contentTypes.schemaFields' | translate}}</span>
  }
</h2>
}

<mat-dialog-content class="schema-dialog-content" [class.embedded-schema-content]="embedded">
  <input #schemaFileInput type="file" accept=".xlsx,.xls,.csv,.json,application/json" hidden (change)="importSchema($event)">
  @if (totalFieldCount) {
  @if (accessView) {
    <section class="access-view">
      <div class="access-view-toolbar">
        <div>
          <h3>{{'contentTypes.accessManagerTitle' | translate}}</h3>
          <p>{{'contentTypes.accessManagerDescription' | translate}}</p>
        </div>
        <div class="access-mode-switch" role="group" [attr.aria-label]="'contentTypes.accessEditMode' | translate">
          <button type="button" [class.active]="!accessBulkMode" [attr.aria-pressed]="!accessBulkMode" (click)="stopAccessBulkEdit()">{{'contentTypes.accessSingleMode' | translate}}</button>
          <button type="button" [class.active]="accessBulkMode" [attr.aria-pressed]="accessBulkMode" (click)="startAccessBulkEdit()">{{'contentTypes.accessBulkMode' | translate}}</button>
        </div>
      </div>
      <div class="access-view-workspace">
        <div class="access-field-list">
          <div class="access-list-filters">
            <mat-form-field appearance="outline" class="access-search">
              <mat-label>{{'contentTypes.accessSearchFields' | translate}}</mat-label>
              <input matInput [(ngModel)]="accessSearch">
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline" class="access-filter">
              <mat-label>{{'contentTypes.accessFilterLabel' | translate}}</mat-label>
              <mat-select [(ngModel)]="accessFilter">
                <mat-option value="all">{{'contentTypes.accessFilterAll' | translate}}</mat-option>
                <mat-option value="custom">{{'contentTypes.fieldAccessRestricted' | translate}}</mat-option>
                @if (!accessBulkMode) {
                  <mat-option value="inherited">{{'contentTypes.fieldAccessInherited' | translate}}</mat-option>
                }
                <mat-option value="open">{{'contentTypes.fieldAccessOpen' | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          @if (accessBulkMode) {
            <div class="access-list-controls">
              <mat-checkbox [checked]="allVisibleAccessRowsSelected" [indeterminate]="someVisibleAccessRowsSelected" [disabled]="!editableVisibleAccessRowCount" (change)="toggleVisibleAccessRows($event.checked)">{{'contentTypes.accessSelectVisible' | translate}}</mat-checkbox>
              <span>{{accessSelectedCount}} {{'contentTypes.accessSelected' | translate}}</span>
              <button mat-button [disabled]="!accessSelectedCount" (click)="clearAccessSelection()">{{'contentTypes.accessClearSelection' | translate}}</button>
            </div>
          }
          <div class="access-rows">
            @for (row of accessRows; track row.path.join('.')) {
              <div class="access-field-row" [class.active]="accessBulkMode ? accessRowSelected(row.path) : isSelectedAccessPath(row.path)">
                @if (accessBulkMode) {
                  <mat-checkbox [checked]="accessRowSelected(row.path)" [disabled]="!accessRowEditable(row.path, row.node)" [attr.aria-label]="row.label" (change)="toggleAccessRow(row.path, $event.checked)"></mat-checkbox>
                }
                <button type="button" class="access-row-target" [disabled]="accessBulkMode && !accessRowEditable(row.path, row.node)" [attr.aria-label]="row.label" [style.padding-left.px]="row.depth * 12" (click)="selectAccessRow(row)">
                  <mat-icon>{{nodeIcon(row.node)}}</mat-icon>
                  <span class="access-field-name" [title]="row.label"><strong>{{row.node.key}}</strong>@if (row.parentLabel) { <small>{{row.parentLabel}}</small> }</span>
                  @if (row.node.access) {
                    <span class="access-status-pill">{{'contentTypes.fieldAccessRestricted' | translate}}</span>
                  } @else if (accessInheritedFromPath(row.path)) {
                    <span class="access-status-pill inherited">{{'contentTypes.fieldAccessInherited' | translate}}</span>
                  }
                </button>
              </div>
            } @empty {
              <p class="access-no-results">{{'contentTypes.accessNoFieldsFound' | translate}}</p>
            }
          </div>
        </div>
        <aside class="access-detail">
          @if (accessBulkMode) {
            <h4>{{'contentTypes.accessBulkRuleTitle' | translate}}</h4>
            <p class="access-detail-hint">{{'contentTypes.accessBulkRuleHint' | translate}}</p>
          } @else if (selectedField) {
            <div class="access-selected-field-heading">
              @if ((selectedFieldPath?.length || 0) > 1) {
                <mat-icon [matTooltip]="selectedAccessPathLabel" [attr.aria-label]="selectedAccessPathLabel">more</mat-icon>
              }
              <h4 [matTooltip]="selectedAccessPathLabel">{{selectedField.key}}</h4>
            </div>
            @if (selectedFieldInheritedAccessFrom) {
              <p class="access-inherited-note" [textContent]="'contentTypes.fieldAccessInheritedHint' | translate: { field: selectedFieldInheritedAccessFrom }"></p>
            }
            <mat-slide-toggle [checked]="!!selectedField?.access" [disabled]="!!selectedFieldInheritedAccessFrom && !selectedField?.access" (change)="setSelectedAccessEnabled($event.checked)">{{'contentTypes.fieldAccessCustom' | translate}}</mat-slide-toggle>
            @if (selectedFieldInheritedAccessFrom && !selectedField?.access) {
              <p class="access-detail-hint">{{'contentTypes.fieldAccessInheritedReadOnly' | translate}}</p>
            }
          }
          @if (accessBulkMode || selectedField?.access) {
              @if (!accessBulkMode) {
                <p class="access-detail-hint">{{'contentTypes.fieldAccessInheritanceHint' | translate}}</p>
              }
              <div class="access-role-table">
                @for (role of accessTargetRoles; track role) {
                  <div class="access-role-item">
                    <div class="access-role-title">
                      <strong>{{role === 'public' ? ('contentTypes.fieldAccessPublic' | translate) : role}}</strong>
                      @if (role !== 'public') {
                        <button mat-icon-button [attr.aria-label]="('contentTypes.fieldAccessRemoveRole' | translate) + ': ' + role" (click)="removeSelectedAccessRole(role)"><mat-icon>delete</mat-icon></button>
                      }
                    </div>
                    <div class="access-role-permissions">
                      @for (permission of role === 'public' ? ['R'] : ['C', 'R', 'U', 'D']; track permission) {
                        <mat-checkbox [checked]="hasSelectedAccessPermission(role, permission)" (change)="setSelectedAccessPermission(role, permission, $event.checked)">{{('contentTypes.fieldAccessPermission.' + permission) | translate}}</mat-checkbox>
                      }
                    </div>
                  </div>
                }
              </div>
              <div class="access-add-role">
                <mat-form-field appearance="outline">
                  <mat-label>{{'contentTypes.fieldAccessRole' | translate}}</mat-label>
                  <input matInput [(ngModel)]="accessNewRole" (keydown.enter)="$event.preventDefault(); addSelectedAccessRole()">
                  @if (accessRoleErrorKey) { <mat-hint>{{accessRoleErrorKey | translate}}</mat-hint> }
                </mat-form-field>
                <button mat-button class="secondary-gray-button" [disabled]="!accessNewRole.trim() || !!accessRoleErrorKey" (click)="addSelectedAccessRole()"><mat-icon>add</mat-icon> {{'contentTypes.fieldAccessAddRole' | translate}}</button>
              </div>
          } @else if (selectedField) {
              <p class="access-detail-hint">{{'contentTypes.accessNoOwnRule' | translate}}</p>
              @if (effectiveSelectedAccess) {
                <div class="access-effective-heading">{{'contentTypes.accessEffectiveRights' | translate}}</div>
                <div class="access-role-table access-effective-table">
                  @for (role of effectiveAccessRoles; track role) {
                    <div class="access-role-item">
                      <div class="access-role-title"><strong>{{role === 'public' ? ('contentTypes.fieldAccessPublic' | translate) : role}}</strong></div>
                      <div class="access-role-permissions">
                        @for (permission of role === 'public' ? ['R'] : ['C', 'R', 'U', 'D']; track permission) {
                          <mat-checkbox [checked]="hasEffectiveAccessPermission(role, permission)" [disabled]="true">{{('contentTypes.fieldAccessPermission.' + permission) | translate}}</mat-checkbox>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
          }
          @if (accessBulkMode) {
            <div class="access-bulk-action">
              <button mat-button class="orange-button" [disabled]="!accessSelectedCount" (click)="applySelectedAccessToChecked()">{{'contentTypes.accessApplyToSelected' | translate}}</button>
              <small>{{'contentTypes.accessApplyHint' | translate}}</small>
            </div>
          } @else if (!selectedField) {
            <p>{{'contentTypes.selectSchemaFieldHint' | translate}}</p>
          }
        </aside>
      </div>
      @if (embedded) {
        <div class="access-view-actions">
          <button mat-button class="secondary-gray-button" (click)="closeAccessView()"><mat-icon>arrow_back</mat-icon>{{'contentTypes.accessBackToSchema' | translate}}</button>
        </div>
      }
    </section>
  } @else {
  @if (!embedded) {
    <section class="schema-intro">
      <div class="intro-icon"><mat-icon>account_tree</mat-icon></div>
      <div>
        <strong>{{'contentTypes.schemaIntroTitle' | translate}}</strong>
        <p>{{'contentTypes.schemaIntroDescription' | translate}}</p>
      </div>
    </section>
  }

  <section class="schema-actions" [attr.aria-label]="'contentTypes.schemaActions' | translate">
    <button mat-button class="orange-button" (click)="addProperty();" data-nar="content-type-schema-add"><mat-icon>add_circle</mat-icon> {{'contentTypes.addSchemaField' | translate}}</button>
    <button mat-button class="secondary-gray-button" (click)="schemaFileInput.click()" data-nar="content-type-schema-import" [matTooltip]="'contentTypes.schemaImportHint' | translate"><mat-icon>upload_file</mat-icon> {{'contentTypes.importSchemaFile' | translate}}</button>
    <button mat-button class="secondary-gray-button" [matMenuTriggerFor]="advancedSchemaActions">
      {{'workTask.advanced_settings' | translate}} <mat-icon>expand_more</mat-icon>
    </button>
    @if (totalFieldCount > 5 || schemaSearch) {
      <mat-form-field class="pt-3 m-2 mb-0 mt-0 schema-search">
        <mat-label>{{'contentTypes.searchSchemaFields' | translate}}</mat-label>
        <input matInput [(ngModel)]="schemaSearch" (keydown.escape)="schemaSearch = ''" [placeholder]="'search' | translate">
        <mat-icon matPrefix>search</mat-icon>
        @if (schemaSearch) {
          <button matSuffix mat-icon-button type="button" [attr.aria-label]="'contentTypes.clearSchemaSearch' | translate" [matTooltip]="'contentTypes.clearSchemaSearch' | translate" (click)="schemaSearch = ''"><mat-icon>close</mat-icon></button>
        }
      </mat-form-field>
    }
  </section>

    <section class="schema-workspace">
      <div class="schema-list">
        <div class="schema-list-header"><span>{{'contentTypes.schemaField' | translate}}</span><span>{{'contentTypes.type' | translate}}</span></div>
        <div>
        @if (schemaSearch.trim()) {
          <div class="schema-search-results">
            @for (result of schemaSearchResults; track result.label) {
              <button type="button" class="schema-search-result" (click)="revealSchemaSearchResult(result)">
                <mat-icon>{{nodeIcon(result.node)}}</mat-icon>
                <span><strong>{{result.node.key}}</strong><small>{{result.label}}</small></span>
                <span class="type-pill">{{schemaTypeLabel(result.node.type)}}</span>
              </button>
            } @empty {
              <p class="schema-search-empty">{{'contentTypes.schemaSearchNoResults' | translate}}</p>
            }
          </div>
        } @else {
        <mat-tree #schemaTree [dataSource]="dataSource" [treeControl]="treeControl" class="schema-tree" cdkDropList [cdkDropListData]="{ nodes: allproperties }" (cdkDropListDropped)="dropFields($event)">
          <mat-tree-node *matTreeNodeDef="let node; let index = index" class="schema-tree-row" cdkDrag [cdkDragData]="node" [class.selected]="isSelectedField(node)" (click)="selectField(node)">
            <mat-icon class="drag-handle" cdkDragHandle [matTooltip]="'contentTypes.schemaDragHint' | translate" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
            <div class="node-main">
              <mat-icon class="node-icon">{{nodeIcon(node)}}</mat-icon>
              <div class="node-copy"><strong>{{node.key}}</strong>@if (node.description) {
              <small>{{node.description}}</small>
            }</div>
          </div>
          <div class="node-meta">
            <span class="type-pill">{{schemaTypeLabel(node.type)}}</span>@if (node.mandatory === true) {
            <span class="required-pill">{{'contentTypes.schemaRequiredField' | translate}}</span>
          }
          <button mat-icon-button [attr.aria-label]="'contentTypes.editSchemaFieldDetails' | translate" (click)="$event.stopPropagation(); editProperty(node, index);"><mat-icon>tune</mat-icon></button>
          <button mat-icon-button [attr.aria-label]="'contentTypes.deleteSchemaField' | translate" class="delete-action" (click)="$event.stopPropagation(); deleteNode(node, index);"><mat-icon>delete</mat-icon></button>
        </div>
      </mat-tree-node>
      <mat-nested-tree-node *matTreeNodeDef="let node; let index = index; when: hasChild" cdkDrag [cdkDragData]="node">
        <div class="schema-tree-row schema-tree-parent" [class.selected]="isSelectedField(node)" (click)="selectField(node)">
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="('contentTypes.toggleSchemaField' | translate) + ' ' + node.key" class="expand-action" (click)="$event.stopPropagation()"><mat-icon>{{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}</mat-icon></button>
          <mat-icon class="drag-handle" cdkDragHandle [matTooltip]="'contentTypes.schemaDragHint' | translate" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
          <div class="node-main">
            <mat-icon class="node-icon">{{nodeIcon(node)}}</mat-icon>
            <div class="node-copy"><strong>{{node.key}}</strong>@if (node.description) {
            <small>{{node.description}}</small>
          }</div>
        </div>
        <div class="node-meta">
          <span class="type-pill">{{schemaTypeLabel(node.type)}}@if (node.type === 'array') { · {{schemaTypeLabel(node.items?.type)}} }</span>@if (node.mandatory === true) {
          <span class="required-pill">{{'contentTypes.schemaRequiredField' | translate}}</span>
          }
        <span class="object-field-count">{{schemaChildren(node).length}} {{'contentTypes.schemaFields' | translate}}</span>
        <button mat-icon-button [attr.aria-label]="'contentTypes.addSchemaChildField' | translate" class="add-child-action" (click)="$event.stopPropagation(); addNewProperty(node, index);"><mat-icon>add</mat-icon></button>
        <button mat-icon-button [attr.aria-label]="'contentTypes.editSchemaFieldDetails' | translate" (click)="$event.stopPropagation(); editProperty(node, index);"><mat-icon>tune</mat-icon></button>
        <button mat-icon-button [attr.aria-label]="'contentTypes.deleteSchemaField' | translate" class="delete-action" (click)="$event.stopPropagation(); deleteNode(node, index);"><mat-icon>delete</mat-icon></button>
      </div>
    </div>
    <div class="nested-fields" [class.example-tree-invisible]="!treeControl.isExpanded(node) || !schemaChildren(node).length" role="group" cdkDropList [cdkDropListData]="{ nodes: schemaChildren(node) }" (cdkDropListDropped)="dropFields($event)">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
  <mat-tree-node *matTreeNodeDef="let node; let index = index; when: isArrayType" class="schema-tree-row" cdkDrag [cdkDragData]="node" [class.selected]="isSelectedField(node)" (click)="selectField(node)">
      <mat-icon class="drag-handle" cdkDragHandle [matTooltip]="'contentTypes.schemaDragHint' | translate" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
      <div class="node-main">
        <mat-icon class="node-icon">{{nodeIcon(node)}}</mat-icon>
        <div class="node-copy"><strong>{{node.key}}</strong>@if (node.description) {
        <small>{{node.description}}</small>
      }</div>
    </div>
    <div class="node-meta">
      <span class="type-pill">{{schemaTypeLabel('array')}}@if (node.items?.type) {
        <span> · {{schemaTypeLabel(node.items.type)}}</span>
      }</span>@if (node.mandatory === true) {
      <span class="required-pill">{{'contentTypes.schemaRequiredField' | translate}}</span>
      }
    <button mat-icon-button [attr.aria-label]="'contentTypes.editSchemaFieldDetails' | translate" (click)="$event.stopPropagation(); editProperty(node, index);"><mat-icon>tune</mat-icon></button>
    <button mat-icon-button [attr.aria-label]="'contentTypes.deleteSchemaField' | translate" class="delete-action" (click)="$event.stopPropagation(); deleteNode(node, index);"><mat-icon>delete</mat-icon></button>
  </div>
</mat-tree-node>
</mat-tree>
        }
</div>
</div>
<aside class="field-editor">
  @if (selectedField) {
    <div class="editor-heading">
      <mat-icon class="node-icon">{{selectedField ? nodeIcon(selectedField) : 'data_object'}}</mat-icon>
      <div>
        <span>{{'contentTypes.selectedSchemaField' | translate}}</span>
        <strong>{{selectedFieldLabel}}</strong>
      </div>
    </div>
    <form [formGroup]="selectedFieldForm" class="editor-form">
      <mat-form-field appearance="outline">
        <mat-label>{{'contentTypes.schemaFieldName' | translate}}</mat-label>
        <input matInput formControlName="key" [placeholder]="'contentTypes.schemaFieldNameExample' | translate">
        @if (selectedFieldForm.get('key')?.hasError('required')) {
          <mat-error>{{'contentTypes.schemaFieldNameRequired' | translate}}</mat-error>
        }
        @if (selectedFieldForm.get('key')?.hasError('pattern')) {
          <mat-error>{{'contentTypes.schemaFieldNamePattern' | translate}}</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{'contentTypes.type' | translate}}</mat-label>
        <mat-select formControlName="type">
          @for (option of typesOptions; track option) {
            <mat-option [value]="option.type">
              <mat-icon>{{option.mat_icon}}</mat-icon>
              <span>{{schemaTypeLabel(option.type)}}</span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (selectedFieldForm.value.type === 'array') {
        <mat-form-field appearance="outline">
          <mat-label>{{'contentTypes.schemaListItemType' | translate}}</mat-label>
          <mat-select formControlName="listItemsType">
            @for (option of listTypesOptions; track option) {
              <mat-option [value]="option.type">
                <mat-icon>{{option.mat_icon}}</mat-icon>
                <span>{{schemaTypeLabel(option.type)}}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <mat-form-field appearance="outline">
        <mat-label>{{'contentTypes.description' | translate}}</mat-label>
        <textarea matInput rows="3" formControlName="description" [placeholder]="'contentTypes.schemaDescriptionHint' | translate"></textarea>
      </mat-form-field>
      <label class="required-toggle" [class.active]="selectedFieldForm.value.mandatory">
        <span><strong>{{'contentTypes.schemaRequiredField' | translate}}</strong><small>{{'contentTypes.schemaRequiredFieldHint' | translate}}</small></span>
        <mat-slide-toggle formControlName="mandatory"></mat-slide-toggle>
      </label>
    </form>
    @if (selectedField?.access) {
      <div class="access-inline-status"><mat-icon>lock_outline</mat-icon>{{'contentTypes.fieldAccessConfigured' | translate}}</div>
    } @else if (selectedFieldInheritedAccessFrom) {
      <div class="access-inline-status"><mat-icon>lock_outline</mat-icon><span [textContent]="'contentTypes.fieldAccessInheritedHint' | translate: { field: selectedFieldInheritedAccessFrom }"></span></div>
    }
    @if (metaTemplate.fields.length) {
      <mat-expansion-panel class="meta-inline-panel" [expanded]="metaExpanded" (opened)="metaExpanded = true" (closed)="metaExpanded = false">
        <mat-expansion-panel-header>
          <mat-panel-title>{{'contentTypes.fieldMetadata' | translate}}</mat-panel-title>
          @if (selectedFieldMissingMetaCount) {
            <mat-panel-description class="meta-missing" [matTooltip]="'contentTypes.metaMissingSummary' | translate: { count: selectedFieldMissingMetaCount }" [attr.aria-label]="'contentTypes.metaMissingSummary' | translate: { count: selectedFieldMissingMetaCount }">{{selectedFieldMissingMetaCount}}</mat-panel-description>
          }
        </mat-expansion-panel-header>
        <div class="meta-inline-body">
          <app-schema-meta-form
            [metaTemplate]="metaTemplate"
            [fieldMeta]="selectedField?.meta"
            [showTemplateEditor]="false"
            [showValuesHeading]="false"
            [showValidationErrors]="true"
            (fieldMetaChange)="updateSelectedFieldMeta($event)">
          </app-schema-meta-form>
        </div>
      </mat-expansion-panel>
    }
    <div class="editor-actions">
      <button mat-button class="secondary-gray-button field-details-button" (click)="openSelectedFieldDetails()"><mat-icon>tune</mat-icon> {{'contentTypes.schemaDetailsAndRules' | translate}}</button>
    </div>
  } @else {
    <div class="select-field-hint">
      <mat-icon>touch_app</mat-icon>
      <h3>{{'contentTypes.selectSchemaField' | translate}}</h3>
      <p>{{'contentTypes.selectSchemaFieldHint' | translate}}</p>
    </div>
  }
</aside>
</section>
  }
} @else {
  <section class="schema-empty-state">
    <mat-icon>upload_file</mat-icon><h3>{{'contentTypes.noSchemaFields' | translate}}</h3>
    <p>{{'contentTypes.noSchemaFieldsHint' | translate}}</p>
    <div>
      <button mat-button class="orange-button" (click)="schemaFileInput.click()" [matTooltip]="'contentTypes.schemaImportHint' | translate"><mat-icon>upload_file</mat-icon> {{'contentTypes.importSchemaFile' | translate}}</button>
      <button mat-button class="secondary-gray-button" (click)="addProperty();"><mat-icon>add_circle</mat-icon> {{'contentTypes.addSchemaField' | translate}}</button>
      <button mat-button class="secondary-gray-button" [matMenuTriggerFor]="advancedSchemaActions">{{'workTask.advanced_settings' | translate}} <mat-icon>expand_more</mat-icon></button>
    </div>
  </section>
}

<mat-menu #advancedSchemaActions="matMenu">
  <button mat-menu-item (click)="openMetaTemplateEditor()"><mat-icon>tune</mat-icon><span>{{'contentTypes.metaTemplate' | translate}}</span></button>
  <button mat-menu-item (click)="openAccessView()" [disabled]="!totalFieldCount"><mat-icon>lock_outline</mat-icon><span>{{'contentTypes.accessManagerTitle' | translate}}</span></button>
  <button mat-menu-item [matMenuTriggerFor]="schemaExportFormats" [disabled]="!totalFieldCount" data-nar="content-type-schema-export"><mat-icon>download</mat-icon><span>{{'contentTypes.exportSchema' | translate}}</span></button>
  <button mat-menu-item (click)="downloadSampleJson()" [disabled]="!totalFieldCount" data-nar="content-type-schema-sample-json"><mat-icon>data_object</mat-icon><span>{{'contentTypes.downloadSampleJson' | translate}}</span></button>
</mat-menu>

<mat-menu #schemaExportFormats="matMenu">
  <button mat-menu-item (click)="exportSchema('json')"><mat-icon>data_object</mat-icon><span>{{'contentTypes.exportAsJson' | translate}}</span></button>
  <button mat-menu-item (click)="exportSchema('xlsx')"><mat-icon>table_view</mat-icon><span>{{'contentTypes.exportAsExcel' | translate}}</span></button>
  <button mat-menu-item (click)="exportSchema('csv')"><mat-icon>table_chart</mat-icon><span>{{'contentTypes.exportAsCsv' | translate}}</span></button>
</mat-menu>

</mat-dialog-content>

@if (!embedded) {
<mat-dialog-actions align="end" class="schema-dialog-footer">
  @if (accessView) {
    <button mat-button class="secondary-gray-button access-footer-back" (click)="closeAccessView()"><mat-icon>arrow_back</mat-icon>{{'contentTypes.accessBackToSchema' | translate}}</button>
  }
    <button mat-button (click)="onCancel();">{{'cancel' | translate}}</button>
  <button mat-button class="orange-button" (click)="onSave();" data-nar="content-type-schema-apply">{{'save' | translate}}</button>
</mat-dialog-actions>
}

<ng-template #schemaImportWarning>
  <h2 mat-dialog-title>{{'contentTypes.schemaImportReplaceTitle' | translate}}</h2>
  <mat-dialog-content>{{'contentTypes.schemaImportReplaceMessage' | translate}}</mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">{{'cancel' | translate}}</button>
    <button mat-button class="orange-button" [mat-dialog-close]="true">{{'contentTypes.importSchemaFile' | translate}}</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #accessBulkWarning>
  <h2 mat-dialog-title>{{'contentTypes.accessBulkConfirmTitle' | translate}}</h2>
  <mat-dialog-content [textContent]="'contentTypes.accessBulkConfirmMessage' | translate: { count: accessSelectedCount }"></mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">{{'cancel' | translate}}</button>
    <button mat-button class="orange-button" [mat-dialog-close]="true">{{'contentTypes.accessApplyToSelected' | translate}}</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #schemaImportWarningsDialog>
  <h2 mat-dialog-title>{{'contentTypes.schemaImportWarningsTitle' | translate}}</h2>
  <mat-dialog-content class="schema-import-warning-content">
    <p class="schema-import-warning-summary" [textContent]="'contentTypes.schemaImportSuccess' | translate: { count: schemaImportFieldCount }"></p>
    <p class="schema-import-warning-intro">{{'contentTypes.schemaImportWarningsMessage' | translate}}</p>
    <p class="schema-import-warning-count" [textContent]="'contentTypes.schemaImportWarningsCount' | translate: { count: schemaImportWarnings.length }"></p>
    <ul class="schema-import-warning-list">
      @for (warning of schemaImportWarnings; track $index) {
        <li>
          @if (warning.path) { <code>{{warning.path}}</code> }
          <span>{{warning.message}}</span>
        </li>
      }
    </ul>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">{{'done' | translate}}</button>
  </mat-dialog-actions>
</ng-template>
